import Image from 'next/image';
import Head from 'next/head';

import { Box, useMediaQuery } from '@chakra-ui/react';

import { ClientsSlideshow } from '../components/ClientsSlideshow';

import { aboutPageIcons, accordionData } from '../data/aboutUsPageData';

import { motion } from 'framer-motion';

import { ChakraAccordion } from '../components/ChakraAccordion';

export const getStaticProps = async () => {
  return {
    props: {
      aboutPageIcons,
      accordionData,
    },
  };
};

const textContainerVariants = {
  hidden: {
    opacity: 0,
  },
  visible: {
    opacity: 1,
  },
};

const iconContainerVariants = {
  hidden: {
    opacity: 0,
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.2,
    },
  },
};

const iconVariants = {
  hidden: {
    scale: 0,
  },
  visible: {
    scale: 1,
  },
};

export default function AboutUsPage({ aboutPageIcons, accordionData }) {
  const [isMobile] = useMediaQuery('(max-width: 768px');

  return (
    <>
      <Head>
        <title>About Us | drive</title>
      </Head>

      <section className="about-us-hero">
        <div className="about-us-hero-box">
          <div className="hero-box-left"></div>
          <div className="hero-box-right">
            <p>
              We are a team of high-energy individuals who believe business
              potential lies in human connection
            </p>
          </div>
        </div>
        <div className="about-us-hero-bg"></div>
      </section>

      <Box as="section" className="about-us-text">
        <Box
          as={motion.div}
          initial="hidden"
          whileInView="visible"
          variants={textContainerVariants}
          className="about-us-text-wrapper"
          position="relative"
        >
          <h2>
            We foster human connection through insightful strategies,
            sophisticated design, and impactful digital experiences
          </h2>

          {accordionData && <ChakraAccordion accordionData={accordionData} />}

          <Box
            as={motion.div}
            position="absolute"
            variants={
              isMobile
                ? {
                    hidden: {
                      scale: 0,
                      y: 700,
                      x: 700,
                      rotate: 0,
                    },
                    visible: {
                      scale: 1,
                      x: 450,
                      y: 0,
                      rotate: 12,
                      transition: {
                        duration: 2,
                      },
                    },
                  }
                : {
                    hidden: {
                      scale: 0,
                      y: 700,
                      x: 700,
                      rotate: 0,
                    },
                    visible: {
                      scale: 1,
                      x: 450,
                      y: -100,
                      rotate: 12,
                      transition: {
                        duration: 2,
                      },
                    },
                  }
            }
            width={{ base: 200, md: 400, lg: 600 }}
            height={{ base: 200, md: 400, lg: 600 }}
            zIndex={0}
            pointerEvents="none"
          >
            <Image
              width={700}
              height={700}
              src={'/drive-icon-gray.svg'}
              alt="drive oscar"
            />
          </Box>
        </Box>
      </Box>

      <section className="what-we-do">
        <div className="section-wrapper">
          <div className="what-we-do-text">
            <h1>What we do</h1>
            <p>
              Too many digital marketing agencies pitch themselves as
              Jack-of-all trades.
            </p>
            <p>
              They claim they can do it all—but after many broken promises, it’s
              clear that they can’t. Instead, we’ve spent years honing our
              skills and mastering the digital marketing strategies that drive
              growth.
            </p>
          </div>
          <motion.div
            className="what-we-do-grid"
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            variants={iconContainerVariants}
          >
            {aboutPageIcons.map(({ src, alt, title }, index) => (
              <motion.div
                key={index}
                className="what-we-do-card"
                variants={iconVariants}
              >
                <Image width={120} height={120} src={`/${src}`} alt={alt} />
                <h3>{title}</h3>
              </motion.div>
            ))}
          </motion.div>
        </div>
      </section>

      <ClientsSlideshow slideShowTitle={'Our amazing partners'} />
    </>
  );
}
